import { ActivityType, CommentStatus, SubscriptionStatus } from './activity.types'
import { ControlStatus } from './controls.types'
import { DocumentLiveStatus, DocumentStagingStatus, DocumentType } from './document.types'

export const StagingStatusLabels: Record<DocumentStagingStatus, string> = {
  [DocumentStagingStatus.PendingUpload]: 'Pending Upload',
  [DocumentStagingStatus.Draft]: 'Draft',
  [DocumentStagingStatus.InternalReview]: 'Internal Review',
  [DocumentStagingStatus.ConsultantReview]: 'Consultant Review',
  [DocumentStagingStatus.AuditReady]: 'Audit Ready',
  [DocumentStagingStatus.Final]: 'Final',
}

export const LiveStatusLabels: Record<DocumentLiveStatus, string> = {
  [DocumentLiveStatus.Staging]: 'Staging',
  [DocumentLiveStatus.Live]: 'Live',
  [DocumentLiveStatus.Archived]: 'Archived',
}

export const DocumentTypeLabels: Record<DocumentType, string> = {
  [DocumentType.Policy]: 'Policy',
  [DocumentType.SOP]: 'SOP',
  [DocumentType.ProcessDiagram]: 'Process Diagram',
  [DocumentType.WorkInstruction]: 'Work Instruction',
  [DocumentType.FormsTemplatesLogs]: 'Forms, Templates & Logs',
}

export const ControlStatusLabels: Record<ControlStatus, string> = {
  [ControlStatus.Undecided]: 'Undecided',
  [ControlStatus.NotApplicable]: 'N/A',
  [ControlStatus.DocumentListPending]: 'Doc List Pending',
  [ControlStatus.DocumentsPending]: 'Docs Pending',
  [ControlStatus.DocumentsReadyForAudit]: 'Ready for Audit',
  [ControlStatus.DocumentsPassedAudit]: 'Passed Audit',
}

/**
 * Converts an enum-to-label record into an array of options suitable for PrimeReact Dropdown/MultiSelect.
 * The value returned is the enum key (integer or string).
 */
export function enumToOptions<T extends string | number>(
  labelRecord: Record<T, string>,
): {
  label: string
  value: T
}[] {
  return Object.entries(labelRecord).map(([value, label]) => ({
    label: label as string,
    // If the record keys are numeric, Object.entries stringifies them. Convert back if needed.
    value: (Number.isNaN(Number(value)) ? value : Number(value)) as T,
  }))
}

export const CommentStatusLabels: Record<CommentStatus, string> = {
  [CommentStatus.Comment]: 'Comment',
  [CommentStatus.OpenIssue]: 'Open Issue',
  [CommentStatus.ClosedIssue]: 'Closed',
}

export const SubscriptionStatusLabels: Record<SubscriptionStatus, string> = {
  [SubscriptionStatus.Subscribed]: 'Subscribed',
  [SubscriptionStatus.MentionOnly]: 'Mention Only',
  [SubscriptionStatus.Muted]: 'Muted',
}

export const ActivityTypeLabels: Record<ActivityType, string> = {
  [ActivityType.CommentCreated]: 'New Comment',
  [ActivityType.CommentReplied]: 'Reply Received',
  [ActivityType.Mention]: 'Mentioned You',
  [ActivityType.IssueOpened]: 'Issue Opened',
  [ActivityType.IssueClosed]: 'Issue Closed',
  [ActivityType.DocStagingStatusChanged]: 'Status Updated',
  [ActivityType.DocLiveStatusChanged]: 'Document Live Status Changed',
  [ActivityType.DocOfficiated]: 'Document Officiated',
  [ActivityType.DocArchived]: 'Document Archived',
  [ActivityType.DocPicAssigned]: 'PIC Reassigned',
  [ActivityType.DocFileUploaded]: 'New File Version',
  [ActivityType.ControlStatusChanged]: 'Control Status Changed',
  [ActivityType.ControlJustificationChanged]: 'Justification Updated',
  [ActivityType.ControlDocMapped]: 'Document Linked',
  [ActivityType.ControlDocUnmapped]: 'Document Unlinked',
}
